<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>    
    <div>
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-3/4 mb-base flex">
        <vx-card class="greet-user overflow-auto pb-5" title="ENTER RECIPIENTS">

          <div>
            <p><span class="font-medium">Recipients entered below will be addressed personally by name.</span></p>
            <div v-for="(contact, i) in specifiedContacts" :key="String('cntc' + i)" class="w-full my-4">
              <div class="md:flex w-full">
                <vs-input class="mr-2 w-full md:w-4/12" placeholder="First name" :name="`First name ${i + 1}`"
                  v-model="contact.name" v-validate="'max:50'" />
                <vs-input class="mr-2 w-full md:w-4/12" placeholder="Email address" data-vv-validate-on="blur"
                  :name="`Email ${i + 1}`" v-model="contact.email" v-validate="'email|required'" />
                <vs-button type="border" class="w-full md:w-10" icon-pack="feather" icon="icon-trash" @click="() => {
                  specifiedContacts.splice(i, 1)
                }"></vs-button>
              </div>
              <span class="block mt-2 text-danger">{{ errors.first(`First name ${i + 1}`) }}</span>
              <span class="block mt-2 text-danger">{{ errors.first(`Email ${i + 1}`) }}</span>
            </div>
            <vs-button type="border" icon-pack="feather" icon="icon-plus-circle" size="small" @click="() => {
              specifiedContacts.push({
                name: '',
                email: ''
              })
            }">Add</vs-button>
          </div>
          <vs-divider class="my-6" />


          <p class="my-2">You may also include a list of just email addresses below.</p>
          <p><span class="font-medium">Email addresses entered below will trigger email invites without a personal greeting. We highly recommend entering names (using the boxes above), so that invites are more personal.</span></p>
          <p class="my-2">Seperate email addresses with commas, semicolons or spaces:</p>

          <vs-textarea v-model.trim="recipients" class="w-full" rows="7"
            placeholder="Jack, Jones <jack.jones@email.com>; jane@doe.com, fred@domain.com" />
          <div class="my-2 flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="stroke-current text-dark w-6 h-6" class="mx-2" />
            <span>You can copy and paste email addresses here from the 'To:' field in your email program.</span>
          </div>
          <div class="my-2 flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="stroke-current text-dark w-6 h-6" class="mx-2" />
            <span>SPAM Policy: We only allow sending to the same email address <span class="font-medium">once every 30 days.</span></span>
          </div>
          <vs-button class="float-right my-2 w-full md:w-auto" size="large" style="min-width: 250px;"
            @click="submitThis">Send</vs-button>
          <vs-button class="float-right m-2 w-full hidden md:inline-block md:w-auto" size="large" type="border"
            @click="() => {
              recipients = ''
            }">Clear</vs-button>
          <p class="text-danger mt-5" v-if="message">{{ message }}</p>
          <p class="text-danger mt-5" v-if="error">{{ error }}</p>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/4 mb-base flex">
        <div class="text-center w-full">
          <vs-button type="border" v-if="!$store.getters['dash/isCollaborator']" class="w-full mb-4"
            @click="$router.push('/dash/settings/lookandfeel')">Change email look and feel</vs-button>
          <vx-card>
            <p>Emails left</p>
            <p class="font-medium text-3xl my-2 text-primary">{{ emailQuota }}</p>
            <p class="text-dark">{{ currentMonthOrTrial }}</p>
          </vx-card>
        </div>
      </div>

    </div>


    <div class="vx-row">
      <div class="vx-col w-full mb-base flex">
        <vx-card title="Email preview" class="pb-4 overflow-x-scroll">
          <vs-collapse type="margin" :open-hover="true" class="small mb-10">
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left p-4">
              <div slot="header">
                Can I change the rating metric on emails?
              </div>
              <span>The rating metric (CSAT/Star/NPS) shown on your invites is determined by the first rating question
                as set up in your survey. If you don’t have a rating question set up in your survey flow, it will
                default to Star rating.</span>
            </vs-collapse-item>
          </vs-collapse>
          <StarPreview v-if="entityRatingType === 'star'" />
          <CSATPreview v-if="entityRatingType === 'csat'" />
          <NPSPreview v-if="entityRatingType === 'nps'" />
        </vx-card>
      </div>
    </div>


    
  </div>
</template>


<script>
import NPSPreview from '../emailpreviewcomponents/npspreview.vue'
import CSATPreview from '../emailpreviewcomponents/csatpreview.vue'
import StarPreview from '../emailpreviewcomponents/starpreview.vue'


function extractEmails(text) {
  return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
}

function getUniques(a) {
  var seen = {};
  return a.filter(function (item) {
    return seen.hasOwnProperty(item.email) ? false : (seen[item.email] = true);
  });
}

export default {
  data() {
    return {      
      recipients: '',      
      specifiedContacts: [{
        name: '',
        email: '',
      },
      {
        name: '',
        email: ''
      }
      ],
      message: false,
      error: false      
    }
  },
  computed: {
    entityRatingType() {
      return this.$store.state.dash.viewData.business.surveySetup.ratingType
    },
    isTrial() {
      return this.$store.getters['dash/subscription'].isTrial
    },    
    businessQuotas() {
      return this.$store.state.dash.viewData.business.inviteQuotas
    },
    emailQuota() {
      if (this.$store.getters['dash/subscription'].isTrial) {
        return this.$store.state.dash.viewData.business.trialEmailQuotaLeft + ' emails'
      } else {
        const d = new Date();
        if (d.getMonth() === this.businessQuotas.quotasCurrentMonth) {
          return this.businessQuotas.emailQuotaCurrent + '/' + this.businessQuotas.emailQuota
        } else {
          return this.businessQuotas.emailQuota + '/' + this.businessQuotas.emailQuota
        }
      }
    },
    textQuota() {
      if (this.isTrial) {
        return this.$store.state.panelState.viewData.business.trialTextQuotaLeft + ' texts'
      } else {
        const d = new Date();
        if (d.getMonth() === this.businessQuotas.quotasCurrentMonth) {
          return this.businessQuotas.textQuotaCurrent + '/' + this.businessQuotas.textQuota
        } else {
          return this.businessQuotas.textQuota + '/' + this.businessQuotas.textQuota
        }
      }
    },
    currentMonthOrTrial() {
      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const d = new Date();
      return this.isTrial ? 'in free trial' : 'for ' + monthNames[d.getMonth()]
    },
    logoUrl: {
      set(v) {
        this.$store.commit('dash/MUTATE_APPEARANCE_INFO', {
          what: 'logoUrl',
          val: v
        })
      },
      get() {
        return this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.logoUrl
      }
    },
    feedbackAddress: {
      set(v) {
        this.$store.commit('dash/MUTATE_FEEDBACKLINK', v.replace(/[^a-zA-Z0-9]/g, ""))
      },
      get() {
        return this.$store.state.dash.viewData.business.publicFeedbackDetail.feedbackAddressHandle
      }
    }
  },
  methods: {
 
    submitForm(recipients, type) {

      console.log('sending email..')
      console.log(recipients)
      //return

      const data = {
        emailList: recipients,
        handle: this.$store.state.dash.viewData.business.feedbackAddressHandle,
        replyTo: this.$store.state.dash.viewData.business.businessInfo.businessEmail,
        businessName: this.$store.state.dash.viewData.business.businessName,
        businessID: this.$store.state.dash.viewData.business.businessID
      }

      if (this.$store.getters['dash/isAgencyClientParentEID']) data.isAgencyClient = true

      this.$vs.loading()

      this.$store.dispatch('dash/INVITE_VIA_EMAIL', data).then((r) => {

        //noconsoleconsole.log(r)

        switch (r.data.status) {
          case 'quotareachedtrial':
            this.error = 'We couldn\'t send your invites because you have reached your trial quota for sending email invites. Choose a plan to send more!'
            break;
          case 'quotareached':
            this.error = 'We couldn\'t send your invites because you have reached your quota for sending emails this month. You can upgrade your plan if you want to send more, or you can wait for next month.'
            break;
          case 'success':
            this.$vs.notify({
              title: `${r.data.numberActualSent} Invites Processed`,
              text: `${r.data.numberActualSent} invites have been processed, and will be sent over the next few minutes.`,
              color: 'success',
              time: 60000,
              iconPack: 'feather',
              icon: 'icon-check'
            })
            if (r.data.actualsRemoved > 0) {
              this.$vs.notify({
              title: `${r.data.actualsRemoved} Invites NOT Processed`,
              text: `Our spam policy (No repeat sends for 30days) prevented ${r.data.actualsRemoved} emails from being sent again. This does not count toward your email quota.`,
              color: 'warning',
              time: 60000,
              iconPack: 'feather',
              icon: 'icon-exclamation'
            })
            }
            
            this.recipients = ''
            this.specifiedContacts = [{
              name: '',
              email: '',
            },
            {
              name: '',
              email: ''
            }
            ]                        
            break;
          default:
            this.error = 'We couldn\'t send your invites - something went wrong with processing your list. Please double check your list of recipients. If you continue having problems, please reach out to support.'
            break;
        }

        this.$vs.loading.close()


      }).catch((e) => {

        this.$vs.loading.close()
        this.error = this.error = 'We couldn\'t send your invites - something went wrong with processing your list. Please double check your list of recipients. If you continue having problems, please reach out to support.'

      })

    },
    submitThis() {



      this.message = false
      this.error = false


      setTimeout(() => {
        let recipientsValid = this.formValid()

        if (recipientsValid.length === 0) {
          this.message = 'You need to enter email recipients we can send to.'
          return
        }

        if (recipientsValid) {
          let recipientsNoDups = getUniques(recipientsValid)
          //noconsoleconsole.log(recipientsNoDups)

          // CHECK QUOTAS AND THEN POST TO SERVER
          this.submitForm(recipientsNoDups, 'email')

        } else {
          
        }
      }, 1)


    },
    formValid() {

      let text = this.recipients

      const contacts = []

      //check if entered contacts are valid:
      if (this.errors.any()) {
        this.message = 'You have errors in your recipient entries, please fix those first.'
        return false
      }

      this.specifiedContacts.forEach((rec) => {
        if (rec.name.trim() !== '' && rec.email.trim() !== '') {
          contacts.push({
            name: rec.name,
            email: rec.email
          })
        }
      })

      try {

        if (text.trim() !== '') {

          let list = extractEmails(text)

          if (list.length === 0) {
            this.message = 'You haven\'t entered any valid email addresses.'
            return false
          }

          if (list.length > 1000) {
            this.message = 'You can only send 1,000 emails at a time. You have entered ' + list.length + ' emails'
            return false
          }

          list.forEach((listItm) => {
            contacts.push({
              email: listItm,
              name: false
            })
          })

        }

        return contacts

      } catch (e) {
        console.log(e)
        this.message = 'There is an error in the emails you entered, make sure there is no invalid characters in addresses specified.'
        return false
      }
      return false
    }
  },
  components: {
    NPSPreview,
    CSATPreview,
    StarPreview
  },
  created() {

    

  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
